"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoyaltyInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const types_1 = require("@framework/types");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
const RoyaltyInput = (props) => {
    const { name = "royalty" } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const contractTemplate = (0, react_hook_form_1.useWatch)({ name: "contractTemplate" });
    (0, react_1.useEffect)(() => {
        if (contractTemplate === types_1.Erc721ContractTemplates.SOULBOUND ||
            contractTemplate === types_1.Erc721ContractTemplates.SOULBOUND_VOTES ||
            contractTemplate === types_1.Erc1155ContractTemplates.SOULBOUND) {
            form.setValue(name, 0);
        }
    }, [contractTemplate]);
    switch (contractTemplate) {
        case types_1.Erc721ContractTemplates.SOULBOUND:
        case types_1.Erc721ContractTemplates.SOULBOUND_VOTES:
        case types_1.Erc1155ContractTemplates.SOULBOUND:
            return null;
        default:
            return (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.CurrencyInput, { required: true, name: name, symbol: "%" });
    }
};
exports.RoyaltyInput = RoyaltyInput;
//# sourceMappingURL=index.js.map